import { variables } from "../../variables";

export default {
    actions: {
        async _createMembership(context, body){
            return await context.rootGetters.api.post(`${variables.serverUrl}/api/v1/memberships`, body);
        },
        async _updateMembership(context, { body, id }){
            return await context.rootGetters.api.put(`${variables.serverUrl}/api/v1/memberships/${id}`, body);
        },
        async _deleteMembership(context, { id }){
            return await context.rootGetters.api.delete(`${variables.serverUrl}/api/v1/memberships/${id}`);
        },
        async _getMembership(context, { pageSize, pageNumber, membershipName }){
            return await context.rootGetters.api.get(`${variables.serverUrl}/api/v1/memberships?pageSize=${pageSize}&pageNumber=${pageNumber}&membershipName=${membershipName}`);
        }
    }
}